var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegressionTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #67bc6b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -1.3,
    y: -1.5,
    width: 86.6,
    height: 99.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_8979_-_Regression_Testing"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.5,42.1c-.6,0-1-.4-1.2-1-.8-4-2.2-7.6-4.3-11-.3-.5-.2-1.1.2-1.5l1.8-1.8-8.9-8.9-1.8,1.8c-.4.4-1,.5-1.5.1-3.4-2.2-7-3.6-11-4.4-.5,0-.9-.6-.9-1.2v-2.1h-11.7v2.1c0,.6-.4,1-.9,1.2-4.1.8-7.7,2.3-11,4.4-.5.3-1.1.2-1.5-.1l-1.8-1.8-8.9,8.9,1.8,1.8c.4.4.5,1,.2,1.5-2.1,3.4-3.6,6.9-4.3,10.9-.1.5-.6.9-1.2.9h-2.2v11.7h2.2c.6,0,1.1.4,1.2,1,.8,4.1,2.2,7.7,4.4,11.1.3.5.2,1.1-.1,1.5l-1.9,1.9,8.9,8.9,1.9-1.9c.4-.4,1-.5,1.5-.2,3.4,2.1,6.9,3.5,10.9,4.3.5,0,1,.6,1,1.2v2.1h11.7v-2.1c0-.6.4-1,1-1.2,4-.8,7.6-2.2,10.9-4.3.5-.3,1.1-.2,1.5.2l1.9,1.9,8.9-8.9-1.9-1.9c-.4-.4-.5-1-.1-1.5,2.2-3.4,3.6-7,4.4-11.1,0-.5.6-1,1.2-1h2.2v-11.6h-2.6ZM41.9,75.3c-15.1,0-27.4-12.3-27.4-27.4s12.3-27.4,27.4-27.4,27.4,12.3,27.4,27.4-12.3,27.4-27.4,27.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.7,53.8h-1.9l-2.9,13.1h3.5l2.8-13.2c-.4,0-.9,0-1.4,0h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.7,56.9l13.2-5v-12.7l-13.2-6v23.8h0ZM37.2,42c0-.6.5-1.2,1.2-1.2s1.2.5,1.2,1.2v7.1c0,.6-.5,1.2-1.2,1.2s-1.2-.5-1.2-1.2v-7.1h0ZM32.4,39.6c0-.6.5-1.2,1.2-1.2s1.2.5,1.2,1.2v11.9c0,.6-.5,1.2-1.2,1.2s-1.2-.5-1.2-1.2c0,0,0-11.9,0-11.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.3,
    y: 39.6,
    width: 7.1,
    height: 11.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.9,39.7v11.7c2.7-.5,4.7-3,4.7-5.8s-2-5.3-4.7-5.8h0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegressionTesting);
export default __webpack_public_path__ + "static/media/Regression Testing.7ab591fbbff8f996dd8e547d7015e039.svg";
export { ForwardRef as ReactComponent };